<template>
  <v-row class="flex-column">
    <v-divider class="mt-5" />
    <v-col>
      <h6 class="title pt-5 pb-2">Notification Preferences</h6>
    </v-col>
    <v-col>
      <v-row>
        <v-col cols="11">
          <span
            >Manage your notifications by trial. Receive notifications daily, either internally or
            by email.</span
          >
        </v-col>
        <v-col>
          <app-button :request="navigateToTrialNotificationPrefs">Edit</app-button>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    navigateToTrialNotificationPrefs() {
      this.$router.push({
        name: 'trial-notification-preferences'
      })
    }
  }
}
</script>
